import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { CatchmentKpiRequest, CatchmentRequest } from "./catchment.types";

export const catchmentApi = api
  .enhanceEndpoints({ addTagTypes: ["catchment"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      catchment: builder.query({
        query: (catchmentRequest: CatchmentRequest) => {
          return {
            url: `admin/catchment`,
            method: RequestMethod.POST,
            body: {
              ...catchmentRequest,
            },
          };
        },
      }),
      catchmentExport: builder.mutation({
        query: (catchmentRequest: CatchmentRequest) => {
          return {
            url: `admin/catchment/export`,
            method: "POST",
            body: {
              ...catchmentRequest,
            },
            responseHandler: (response) => response.blob(), // Maneja la respuesta como un blob
          };
        },
      }),
      catchmentKpi: builder.query({
        query: (catchmentKpiRequest: CatchmentKpiRequest) => {
          return {
            url: `admin/catchment/kpis`,
            method: RequestMethod.POST,
            body: {
              ...catchmentKpiRequest,
            },
          };
        },
      }),

      // NEW ENDPOINTS
    }),
  });

export const {
  useCatchmentQuery,
  useCatchmentExportMutation,
  useCatchmentKpiQuery,
  useLazyCatchmentKpiQuery,
} = catchmentApi;
